// Khatabook data as the backend (KhataBookRestController) and the mobile app use it:
//   customers   -> response.khataBookCustomers  { id, customer_name, phone, totalBalance }
//   transactions-> response.khataTransactions   { id, amount, type: CREDIT|DEBIT, mode: CASH|ONLINE|UPI, note, transactionDate }
//   summaries   -> { totalCredit, totalDebit, totalBalance }
//   books       -> response.khatabooks          { id, name: HOME|OFFICE }, created once per user by POST /create (no body)

export const TX_MODES = [
  { value: "CASH", label: "Cash" },
  { value: "ONLINE", label: "Online" },
];

export const customerName = (c) => c?.customer_name || c?.name || "";
export const customerPhone = (c) => c?.phone || "";

export const bookLabel = (book) => {
  const name = String(book?.name || "");
  return name ? name.charAt(0) + name.slice(1).toLowerCase() : `Book #${book?.id}`;
};

export const isCredit = (tx) => String(tx?.type || "").toUpperCase() === "CREDIT";

const pad = (n) => String(n).padStart(2, "0");

/** Local YYYY-MM-DD for <input type="date">. */
export const todayDate = () => {
  const d = new Date();
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
};

/** The date part of the API's transactionDate (YYYY-MM-DDTHH:mm:ss), or today. */
export const dateInputValue = (apiDate) => (apiDate ? String(apiDate).slice(0, 10) : todayDate());

/**
 * transactionDate for the API (LocalDateTime, same shape the mobile app sends).
 * Keeps the original time when an edited transaction keeps its date, otherwise uses the current time.
 */
export const toApiDateTime = (dateValue, originalApiDate) => {
  if (originalApiDate && String(originalApiDate).slice(0, 10) === dateValue) {
    return String(originalApiDate).slice(0, 19);
  }
  const now = new Date();
  return `${dateValue}T${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`;
};

export const formatTxDate = (apiDate) => {
  if (!apiDate) return "";
  const d = new Date(apiDate);
  return Number.isNaN(d.getTime())
    ? ""
    : d.toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" });
};

export const inr = (value) => `₹${Number(value || 0).toLocaleString("en-IN")}`;
